import { GridColumnType } from "../../../../components/molGrid/libs/data/gridColumnType";

export const clientPlansGridConfig = {
  isRowSelectable: true,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "Name",
      fieldName: "planName",
      colStyle: {
        textAlign: "left",
        width: "64%",
      },
      allowShort: true,
    },
    {
      name: "Plan Year Month",
      fieldName: "planYearMonth",
      colStyle: {
        textAlign: "center",
        width: "15%",
      },
      allowShort: true,
    },
    {
      name: "Plan Year Day",
      fieldName: "planYearDay",
      colStyle: {
        textAlign: "center",
        width: "15%",
      },
      allowShort: true,
    },
    
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: false,
      },
      
      colStyle: {
        width: "6%",
      },
      allowShort: false,
    },
  ],
};
